import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './VisitInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const VisitInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let visitId: ReactElement | null = null;
    if (props.connectedVehicle.vehicleVisitId) {
        visitId =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.VehicleVisitId}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.vehicleVisitId}
                </div>
            </span>;
    }

    let checkIn: ReactElement | null = null;
    if (props.connectedVehicle.checkInTstamp) {
        checkIn =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.CheckInDate}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.checkInTstamp}
                </div>
            </span>;
    }

    let dealerCode: ReactElement | null = null;
    if (props.connectedVehicle.dealerCode) {
        dealerCode =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.DealerCode}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.dealerCode}
                </div>
            </span>;
    }

    let dealerName: ReactElement | null = null;
    if (props.connectedVehicle.dealerName) {
        dealerName =
            <span className={css.infoBlock}>
                <div className={css.infoLit}>
                    {strings.DealerName}
                </div>
                <div className={css.infoData}>
                    {props.connectedVehicle.dealerName}
                </div>
            </span>;
    }

    return (
        <div className={css.block}>
            <div className={css.icon}>
                <IconSeeMore onClick={() => toggleInfo()} />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.VisitInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {visitId}
                        {checkIn}
                        {dealerCode}
                        {dealerName}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default VisitInformation;